import { Route, Routes } from 'react-router-dom';
import { PopupsPage } from './PopupsPage';
import { ModifyPopupPage } from './ModifyPopupPage';

export const PopupPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyPopupPage />} />
    <Route path='/:popupID' element={<ModifyPopupPage />} />
    <Route path='*' element={<PopupsPage />} />
  </Routes>
);
